'use strict';

function _SubscriptionsMap() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;

  this.subscriptionsMap = {
    id_protect: 'creditAlertsSubscription', // legacy
    id_protect_annual: 'creditAlertsSubscription', // legacy
    id_protect_free: 'creditAlertsSubscription'
  };

  this.init = function () {};
  this.initAllReady = function () {};
}